import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import { ShieldCheck, Lock, User } from "lucide-react";

export default function Login() {
  const { signIn } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await signIn(username.trim(), password);
    } catch (err) {
      setError(err?.response?.data?.detail || "Invalid username or password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left brand panel */}
      <div className="hidden md:flex w-[42%] flex-col justify-between p-10 text-white" style={{ background: "var(--kcsa-red)" }}>
        <div className="flex items-center gap-2.5">
          <ShieldCheck className="w-6 h-6" />
          <span className="text-lg font-bold tracking-wide">StockFlow</span>
        </div>
        <div>
          <h1 className="text-4xl font-bold leading-tight tracking-tight">Inventory Advisor</h1>
          <p className="mt-3 text-white/80 text-[15px] max-w-sm">Real-time stock health, PO recommendations and working-capital visibility across every warehouse.</p>
        </div>
        <div className="text-[11px] uppercase tracking-widest text-white/70">Mining Procurement · Operational View</div>
      </div>

      {/* Right form */}
      <div className="flex-1 grid place-items-center bg-[var(--surface)] p-6">
        <form onSubmit={submit} className="w-full max-w-sm kcard p-7" data-testid="login-form">
          <div className="md:hidden flex items-center gap-2 mb-6">
            <ShieldCheck className="w-6 h-6" style={{ color: "var(--kcsa-red)" }} />
            <span className="text-lg font-bold">StockFlow</span>
          </div>
          <div className="label-eyebrow">Welcome back</div>
          <h2 className="text-xl font-bold text-slate-900 mt-1 mb-6">Sign in to StockFlow</h2>

          <label className="label-eyebrow block mb-1">Username</label>
          <div className="relative mb-4">
            <User className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input value={username} onChange={(e) => setUsername(e.target.value)} data-testid="login-username" autoFocus
              className="w-full h-10 pl-9 pr-3 rounded-md border border-[var(--line)] text-[14px] outline-none focus:border-slate-400" placeholder="VijayG" />
          </div>

          <label className="label-eyebrow block mb-1">Password</label>
          <div className="relative mb-5">
            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="w-full h-10 pl-9 pr-3 rounded-md border border-[var(--line)] text-[14px] outline-none focus:border-slate-400" placeholder="••••••••" />
          </div>

          {error && <div className="mb-4 text-[13px] text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="login-error">{error}</div>}

          <button type="submit" disabled={busy} data-testid="login-submit"
            className="w-full h-10 rounded-md text-white text-sm font-semibold disabled:opacity-60" style={{ background: "var(--kcsa-red)" }}>
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
